export default function () {
  return [
    {
      title: {
        pl: 'Strona główna',
        en: 'Homepage'
      },
      to: '/kokpit',
      htmlBefore: '<i class="material-icons">home</i>',
      htmlAfter: '',
      permission: 'home'
    },
    {
      title: {
        pl: 'Powiadomienia',
        en: 'Notifications'
      },
      to: '/powiadomienia',
      htmlBefore: '<i class="material-icons">alarm</i>',
      htmlAfter: '',
      permission: 'notifications'
    },
    {
      title: {
        pl: 'Twoje konto',
        en: 'Your account'
      },
      to: '/moje-konto',
      htmlBefore: '<i class="material-icons">verified_user</i>',
      htmlAfter: '',
      permission: 'profile'
    },
    {
      title: {
        pl: 'Wyloguj się',
        en: 'Logout'
      },
      htmlBefore: '<i class="material-icons">power_settings_new</i>',
      htmlAfter: '',
      to: '/wyloguj',
      permission: false
    }
  ]
}
